import { frontendURL } from '../../../helper/URLHelper';

const CompaniesView = () => import('./pages/CompaniesView.vue');
const CompanyDetailsView = () => import('./pages/CompanyDetailsView.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/companies'),
      name: 'companies_dashboard',
      meta: {
        permissions: ['administrator'],
      },
      component: CompaniesView,
    },
    {
      path: frontendURL('accounts/:accountId/companies/:companyId'),
      name: 'company_details',
      meta: {
        permissions: ['administrator'],
      },
      component: CompanyDetailsView,
      props: route => ({ companyId: route.params.companyId }),
    },
  ],
};